import { useModal } from '@solinkcorp/solink-components';
import { Button, cn } from '@solinkcorp/solink-ui';
import { setFilter } from 'actions/filterActions';
import SpotCheckPanel from 'components/SpotCheckPanel/Aspen/SpotCheckPanel';
import { Sparkles } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import useLocale from 'src/hooks/useLocale';
import { useDispatch, useSelector } from 'stores/store';
import { EVENTS_URL } from 'utils/urls';

const headerButtonClassName =
  'tw shrink-0 border-border-muted bg-background-surface text-interaction-neutral-content-default shadow-none hover:bg-background-muted hover:text-interaction-neutral-content-default dark:border-border-muted dark:bg-background-surface dark:text-interaction-neutral-content-default dark:hover:bg-background-muted dark:hover:text-interaction-neutral-content-default';

const headerButtonActiveClassName =
  'tw border-transparent bg-interaction-primary-background-default text-interaction-primary-content-default hover:bg-interaction-primary-background-hover hover:text-interaction-primary-content-default dark:border-transparent dark:bg-interaction-primary-background-default dark:text-interaction-primary-content-default dark:hover:bg-interaction-primary-background-hover dark:hover:text-interaction-primary-content-default';

export default function Sidekick() {
  const spotCheckPanelProps = useModal();
  const cameraSelectMode = useSelector((state) => state.filter.cameraSelectMode);
  const dispatch = useDispatch();
  const location = useLocation();
  const openEventSpotCheckMode = location.pathname.includes(EVENTS_URL);
  const isSpotCheckCameraSelectMode = cameraSelectMode === 'spot-check';
  const openModal = () => {
    spotCheckPanelProps.openModal();
    dispatch(
      setFilter({
        spotCheckMode: openEventSpotCheckMode ? 'event' : 'scheduled',
        cameraSelectMode: null,
      }),
    );
  };
  const locale = useLocale();
  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="default"
        className={cn(
          headerButtonClassName,
          isSpotCheckCameraSelectMode && headerButtonActiveClassName,
        )}
        onClick={(event) => {
          openModal();
          event.currentTarget.blur();
        }}
      >
        <Sparkles className="size-4" />
        {locale.scheduledAIChat.spotCheck}
      </Button>
      {spotCheckPanelProps.isModalOpen && <SpotCheckPanel {...spotCheckPanelProps} />}
    </>
  );
}
